var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tooltip',{staticClass:"item m-4",attrs:{"popper-class":"tooltip-logo-club","content":_vm.clubName}},[_c('div',{staticClass:"rounded-circle",style:({ backgroundImage: `url('${_vm.clubLogo}')` })},[(_vm.clubUrl)?_c('a',{staticClass:"stretched-link",attrs:{"target":"_blank","href":_vm.clubUrl}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }